import { render, staticRenderFns } from "./MoreVertical.vue?vue&type=template&id=0a476f39"
import script from "./MoreVertical.vue?vue&type=script&lang=js"
export * from "./MoreVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports